import { Component } from 'shimmer'

import { ToCanvas } from '@/utils/ToCanvas'
import {
  PlaneBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  LinearMipmapNearestFilter,
  NearestFilter,
  RGBAFormat,
  FloatType,
  UVMapping,
  CanvasTexture,
  ClampToEdgeWrapping
} from 'three'

export class Screen extends Component {
  constructor (url, size, factor = 1) {
    super('Screen')

    this.onPlay = this.onPlay.bind(this)
    this.onDestroy = this.onDestroy.bind(this)

    this.url = url
    this.isPlaying = false

    this.toCanvas = new ToCanvas({ video: this.url, width: size.width * factor, height: size.height * factor })
    // this.texture = new CanvasTexture(this.toCanvas.canvas, UVMapping, ClampToEdgeWrapping, ClampToEdgeWrapping, NearestFilter, LinearMipmapNearestFilter, RGBAFormat, FloatType)
    this.texture = new CanvasTexture(this.toCanvas.canvas)

    const geometry = new PlaneBufferGeometry(size.width, size.height)
    const material = new MeshBasicMaterial({ map: this.texture, depthWrite: false })
    // const material = new MeshBasicMaterial(0xff0000)
    this.object = new Mesh(geometry, material)
    this.object.position.y = size.height * .5
    this.object.renderOrder = 1

    this.add(this.object)
  }

  onPlay () {
    this.isPlaying = true
    this.toCanvas.start()
  }

  onUpdate () {
    if (this.isPlaying) {
      this.texture.needsUpdate = true
    }
  }

  onDestroy () {
    this.destroy()
    this.texture.dispose()
  }
}